<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'金融合作伙伴管理'},{name:'会员单位管理',goback:true},{name:'编辑会员单位'}]" :title="'编辑会员单位'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>申请人姓名：</div>
                        <div class="content">
                          <el-input v-model="sendInfo.userName" maxlength="20" placeholder="限20字"></el-input>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.userName']">错误提示：{{errors['sendInfo.userName']}}</div>
                    <div class="child">
                        <div class="name"><span>*</span>联系手机号：</div>
                        <div class="content">
                           <el-input v-model="sendInfo.phone" maxlength="11" placeholder="限11字"></el-input>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.phone']">错误提示：{{errors['sendInfo.phone']}}</div>
                    <div class="child">
                        <div class="name"><span>*</span>公司全称：</div>
                        <div class="content">
                           <el-input v-model="sendInfo.companyName" maxlength="20" placeholder="限20字"></el-input>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.companyName']">错误提示：{{errors['sendInfo.companyName']}}</div>
                    <div class="child">
                        <div class="name"><span>*</span>公司行业：</div>
                        <div class="content">
                           <!-- <el-input v-model="sendInfo.provinceId" maxlength="20" placeholder="限20字"></el-input> -->
                            <el-select v-model="sendInfo.industry" placeholder="请选择">
                              <el-option
                            v-for="item in industry"
                            :key="item.id"
                            :label="item.dictName"
                            :value="item.id">
                            </el-option>
                            </el-select>
                        </div>
                        
                    </div>
                    <div class="error" v-if="errors['sendInfo.industry']">错误提示：{{errors['sendInfo.industry']}}</div>
                    
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                           <div class="singleBtn">
                            <el-button type="primary" size="small" @click="submit">保存</el-button>
                            <el-button  size="small" @click="$router.back(-1)">取消</el-button>
                          </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            
        </div>
</template>

<script>
import {API} from "@/axios/config";
import breadcrumb from '../../components/breadcrumb';
import upLoadFiles from '../../components/upLoadFiles';
import wangEnduit from '../../components/Editor/index';
import {getDict} from "@/axios";
export default {
    components:{
        breadcrumb,
        upLoadFiles,
        wangEnduit
    },
    data(){
        return{
          dialogVisible:false,
            statusList: [],//服务类型
		      	id:'',
            sendInfo:{
                id:void 0,// ，编辑时必传
                companyName: void 0, // 公司名称
                industry: void 0, // 行业id
                logoUrl: void 0,// logo地址
                phone: void 0,// 电话
                userName: void 0, // 申请人姓名
            },
            industry:[],//行业
			dict:{
				currentPage:1,
				direction:null,
				pageSize:10,
				parentId :1069409909080064,
				property:null,
			}
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
	created() {
		this.getProvince()
		if(this.$route.params.id){
		    this.id=this.$route.params.id;
		 	this.sendInfo.id=this.$route.params.id;
			this.getDetail();
		}
		
	},
    vuerify: {
		'sendInfo.companyName':{
		    test:function(val){
		        if(val){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'请填写公司全称'
		},
		'sendInfo.phone':{
		    test:function(val){
		        if(val){
                const reg = /^1[0-9]{10}$/
                if(!reg.test(val)){
                  this.errors['sendInfo.phone'] = '请填写正确的手机号码'
                  return false
                }else return true;
		        }else{
                this.errors['sendInfo.phone'] = '请填写手机号'
		            return false;
		        }
		    },
		    message:'请填写手机号'
		},
        'sendInfo.userName':{
            test:function(val){
                if(val){
                    return true;
                }else{
                    return false;
                }
            },
            message:'请填写申请人姓名'
        },
        'sendInfo.industry':{
            test:function(val){
                if(val){
                    return true;
                }else{
                    return false;
                }
            },
            message:'请选择公司行业'
        }
    },
    methods:{
      async getProvince(){
        this.$axiosz.get('/rpc/sysDict/parentId/1069409825193984').then(res=>{
			    if(res.code==200){
					this.industry=res.data
			    }else{
			        this.$message.info(res.msg)
			    }
			})
      },
      onPrivew(){
          if(!this.sendInfo.content || !this.sendInfo.content.trim()){
            this.$message.info('暂无内容不能预览')
            return 
          }
          this.dialogVisible = true
        },
		getDetail(){
			this.$axiosc.get('/backstage/vipUnit/findVipUnitDetails/'+this.id).then((r)=>{
			    if(r.code==200){
              const param = {
                id:this.id,// ，编辑时必传
                companyName: r.data.companyName, // 公司名称
                industry: r.data.industry, // 行业id
                logoUrl: r.data.logoUrl,// logo地址
                phone:  r.data.phone,// 电话
                userName:  r.data.userName // 申请人姓名
              }
					
					this.sendInfo=param;
			    }else{
			        this.$message.info(r.msg)
			    }
			})
		},
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
              this.$axioscBody.post('/backstage/vipUnit/saveVipUnit',this.sendInfo).then((r)=>{
                if(r.code==200){
                  this.$message({
                    type: 'success',
                    message: r.msg
                  });
                  this.$router.back();
                }else{
                  this.$alert(r.msg);
                }
              })
            }
        },
        /** 富文本编辑器图片上传 */
    handleUploadEditor(file, callback) {
      const that = this
      const formData = new window.FormData()
      formData.append('file', file)
      // 上传 todu
      that.$axiosz.post(API.UploadsService + "backstage/annex/file", formData).then(res => {
        const {data,code,msg} = res
        if(code === 200){
        const { frontPath, filePath,fileName } = data
        const param = { ...data }
        param.name = fileName
        param.url = frontPath + filePath
        callback(param)
        }
      }).catch(e => {
        // that.$message.info('上传失败')
        that.$alert('上传失败')
        console.log(e)
      })
    },
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:95.5%;
     overflow: hidden;
    .box{
        padding-top:20px;
        height:calc(94% - 20px);
     overflow-x: hidden;
     overflow-y: auto;
        .forms{
            max-width: 750px;
            margin: auto;
            .child{
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.hint{
				padding-left: 100px;
			}
			.singleBtn{
				text-align: left;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>